import { loadView } from '@/router'

export default [
  {
    path: 'assets',
    name: 'manage-assets',
    component: loadView('Application/Manage/Assets'),
    showInAlfred: true,
    alfredTitle: 'Manage - Assets'
  }
]
